var scrollY;
var lockScroll = function () {
    scrollY = window.scrollY;
    document.body.classList.add('is-locked');
};
var unlockScroll = function () {
    document.body.classList.remove('is-locked');
    window.scrollTo(0, scrollY);
};
var syncHeight = function () {
    document.body.style.setProperty('--window-inner-scrollY', "".concat(window.scrollY, "px"));
};

export { lockScroll, syncHeight, unlockScroll };
